import { Component } from '@angular/core';

@Component({
  selector: 'app-success-message-balance',
  standalone: false,
  templateUrl: './success-message-balance.component.html',
  styleUrls: ['./success-message-balance.component.scss'],
})
export class SuccessMessageBalanceComponent {}
